import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    UpdateMovie,
    UpdateMovieMutation,
    UpdateMovieMutationVariables,
    DeleteMovieMutation,
    DeleteMovieMutationVariables,
    CreateMovie,
    CreateMovieMutation,
    CreateMovieMutationVariables,
    UpdateCinemaMutation,
    UpdateCinemaMutationVariables,
    UpdateCinema,
    ImportMovieMutation,
    ImportMovieMutationVariables,
    CreateTag,
    CreateTagCategory,
    MutationUpdateMovieTagArgs,
    MutationUpdateMovieTagCategoryArgs,
    TagType,
    CreateMovieTagCategory,
    MutationCreateMovieTagCategoryArgs,
    MutationCreateMovieTagArgs,
    UpdateTag,
    MutationDeleteMovieTagArgs,
    MutationDeleteMovieTagCategoryArgs,
    UpdateTagCategory,
} from 'generated/graphql'

const createMovieMutation = gql`
    mutation createMovie($data: CreateMovie!) {
        createMovie(data: $data) {
            id
        }
    }
`
export const createMovie = (data: CreateMovie) => {
    const mutation = graphql.createQuery<
        CreateMovieMutation,
        CreateMovieMutationVariables
    >(createMovieMutation)
    return mutation({ data })
}

const updateMovieMutation = gql`
    mutation updateMovie($id: ID!, $data: UpdateMovie!) {
        updateMovie(id: $id, data: $data) {
            id
        }
    }
`
export const updateMovie = (id: number, data: UpdateMovie) => {
    const mutation = graphql.createQuery<
        UpdateMovieMutation,
        UpdateMovieMutationVariables
    >(updateMovieMutation)
    return mutation({ id: id.toString(), data })
}

export const updateMovieOrder = (id: number, order: number) => (
    updateMovie(id, { order })
)

export const updateMoviePublished = (id: number, published: boolean) => (
    updateMovie(id, { published })
)

const deleteMovieMutation = gql`
    mutation deleteMovie($id: ID!) {
        deleteMovie(id: $id)
    }
`
export const deleteMovie = graphql.createQuery<
    DeleteMovieMutation, DeleteMovieMutationVariables
>(deleteMovieMutation)

const updateCinemaMutation = gql`
    mutation updateCinema($id: Int!, $data: UpdateCinema!) {
        updateCinema(id: $id, data: $data) {
            id
            parent {
                image
            }
        }
    }
`
export const updateCinema = (id: number, data: UpdateCinema) => {
    const mutation = graphql.createQuery<
        UpdateCinemaMutation, UpdateCinemaMutationVariables
    >(updateCinemaMutation)
    return mutation({ id, data })
}

const importMovieMutation = gql`
    mutation importMovie($cinemaSpace: ID!, $data: [ImportMovie!]!) {
        importMovie(cinemaSpace: $cinemaSpace, data: $data) {
            successCount
            errorCount
            errorItems {
                id
                message
                hiddenMessage
            }
        }
    }
`
export const importMovies = (cinemaSpace, data) => {
    const mutation = graphql.createQuery<
        ImportMovieMutation, ImportMovieMutationVariables
    >(importMovieMutation)
    return mutation({ cinemaSpace, data })
}

const createMovieTagCategory = gql`
    mutation createMovieTagCategory($data: CreateMovieTagCategory!) {
        createMovieTagCategory(data: $data) {
            id
        }
    }
`

const createMovieTagMutation = gql`
    mutation createMovieTag($data: CreateTag!) {
        createMovieTag(data: $data) {
            id
        }
    }
`
const updateMovieTagMutation = gql`
    mutation updateMovieTag($data: UpdateTag!, $id: ID!) {
        updateMovieTag(data: $data, id: $id) {
            id
        }
    }
`

const deleteMovieTagMutation = gql`
    mutation deleteMovieTag($id: ID!) {
        deleteMovieTag(id: $id)
    }
`

const updateMovieTagCategoryMutation = gql`
    mutation updateMovieTagCategory($data: UpdateTagCategory!, $id: ID!) {
        updateMovieTagCategory(data: $data, id: $id) {
            id
        }
    }
`

const deleteMovieTagCategoryMutation = gql`
    mutation deleteMovieTagCategory($id: ID!) {
        deleteMovieTagCategory(id: $id)
    }
`

export const createMovieCategory = (data: CreateTagCategory) => {
    const query = graphql.createQuery<
        CreateMovieTagCategory, MutationCreateMovieTagCategoryArgs
        >(createMovieTagCategory)
    return query({ data })
}

export const updateMovieCategory = (id, text) => {
    const query = graphql.createQuery<
    UpdateTagCategory, MutationUpdateMovieTagCategoryArgs>(updateMovieTagCategoryMutation)
    return query({ data: { text }, id })
}

export const deleteMovieTagCategory = (id) => {
    const query = graphql.createQuery<
        any, MutationDeleteMovieTagCategoryArgs
        >(deleteMovieTagCategoryMutation)
    return query({ id })
}

export const createMovieTag = (data: CreateTag) => {
    const query = graphql.createQuery<
        CreateTag, MutationCreateMovieTagArgs
        >(createMovieTagMutation)
    return query({ data })
}

export const updateMovieTag = ({ text, color, categoryId }, id) => {
    const query = graphql.createQuery<
        UpdateTag, MutationUpdateMovieTagArgs
        >(updateMovieTagMutation)
    return query({ data: { text, color, categoryId }, id })
}

export const deleteMovieTag = (id) => {
    const query = graphql.createQuery<
        any, MutationDeleteMovieTagArgs
        >(deleteMovieTagMutation)
    return query({ id })
}

export const updateMovieTagOrder = (id, order, categoryId) => {
    const query = graphql.createQuery<TagType, MutationUpdateMovieTagArgs>(updateMovieTagMutation)
    return query({ data: { order, categoryId: categoryId || null }, id })
}

export const updateMovieCategoryOrder = (id, order) => {
    const query = graphql.createQuery<
        UpdateTag, MutationUpdateMovieTagCategoryArgs>(updateMovieTagCategoryMutation)
    return query({ data: { order }, id })
}
